import { render, staticRenderFns } from "./ViewReportsTotalMadrilla.vue?vue&type=template&id=5444e3b2&scoped=true"
import script from "./ViewReportsTotalMadrilla.vue?vue&type=script&lang=js"
export * from "./ViewReportsTotalMadrilla.vue?vue&type=script&lang=js"
import style0 from "./ViewReportsTotalMadrilla.vue?vue&type=style&index=0&id=5444e3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5444e3b2",
  null
  
)

export default component.exports